/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import helpers from '../base/helpers';
import template from './info.stache';
import dotdotdot from 'dotdotdot';
import dtm from 'scripts/services/dtm';

Component.extend({
    tag: 'card-info',
    template: template,
    viewModel: {
        define: {
            isTruncated: {
                type: 'boolean',
                value: false,
            },
        },
    },
    helpers,
    events: {
        inserted() {
            this.handleReceiveData();
        },

        handleReceiveData() {
            this.htmlDescriptionBox = this.element.find('.s-description');
            this.htmlDescriptionBox.dotdotdot({
                height: 90,
                watch: true,
                callback: (isTruncated) => {
                    this.viewModel.attr('isTruncated', isTruncated);
                },
            });
        },

        '.s-read-more click'(element, event) {
            this.htmlDescriptionBox.trigger('destroy');
            this.viewModel.attr('isTruncated', false);

            dtm.trackInfoCardExpand(this.element.find('.s-title').text());
        },
    },
});
